import React, { useContext } from 'react';
import Footer from '../../Components/Footer';
import TopLeftMenu from '../../Components/TopLeftMenu';
import Menu from '../../Components/Menu';
import ApartamentList from '../../Components/ApartamentList';
import GrafismBottom from '../../assets/grafismo-left-bottom.png';
import GrafismoTop from '../../assets/grafismo-top.png';
import Cookies from '../Cookies';
import BannerDownloadApp from '../BannerDownloadApp';
import { Flags } from 'react-feature-flags';

import { ContextoListaApartamentos } from '../ApartamentList/contextoImoveis';

import './styles.scss';
import useWindowDimension from '../../hooks/WindowDimension';
import { useLocation } from 'react-router-dom';
const Interna = ({ children, overflow }) => {
  // definição do tema atual
  const { tema } = useContext(ContextoListaApartamentos);
  const dimensions = useWindowDimension();
  const location = useLocation();
  return (
    <>
      <div
        className='interna centralized-column'
        style={{ overflow: overflow }}
      >
        <img className='interna__grafismoLeft' src={GrafismBottom} alt='' />
        <img className='interna__grafismoCenter' src={GrafismBottom} alt='' />
        <img className='interna__grafismoTop' src={GrafismoTop} alt='' />
        <div className='interna__container'>
          <TopLeftMenu tema={tema} />
          {((dimensions.winWidth < 1025 && location.pathname === '/interna') ||
            dimensions.winWidth > 1025) && <BannerDownloadApp tema={tema} />}

          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '22px',
              padding: '24px',
            }}
          >
            <ApartamentList />
            <div className='menuDesktop'>
              <Menu tema={tema} />
            </div>
            {children}

            <Flags authorizedFlags={['ambiente-teste']}>
              <div style={{ width: '100%' }}>
                <Cookies />
              </div>
            </Flags>
          </div>
        </div>
        <Footer tema={tema} />

        {/* div para mostrar o resumo das parcelas selecionadas no financeiro */}
        <div id={'divResumoParcelasSelecionadas'}></div>
      </div>
    </>
  );
};

export default Interna;
